<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap">
  <!-- Contenet page started-->
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <ul class="breadcrumb">
          <li><a routerLink="/home">Ambro Live</a></li>
          <li><a>Water Quality</a></li>
        </ul>
      </div>
      <!-- breadcrumb End -->
      <!-- START BASIC TABLE SAMPLE -->
      <div class="panel panel-default">
        <div class="panel-body table-responsive">
          <table class="table table-responsive-md table-striped text-center">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingReadings('farm')">FARM NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondfarmAsc,'glyphicon-chevron-down':!pondfarmAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingReadings('locationname')">LOCATION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondlocationnameAsc,'glyphicon-chevron-down':!pondlocationnameAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingReadings('sectionname')">SECTION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondsectionnameAsc,'glyphicon-chevron-down':!pondsectionnameAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingReadings('pondname')">POND NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondnameAsc,'glyphicon-chevron-down':!pondnameAsc}"></span>
              </th>
              <th>DATE
              </th>
              <th>DEVICE SERIAL ID
              </th>
              <th>PREPARATORY STAGE</th>
              <th>NO. OF TESTS</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of readings; let i = index">
              <td>{{i + 1 }}</td>
              <td>{{ list && list.FarmSiteDetails && list.FarmSiteDetails[0].businessID && list.FarmSiteDetails[0].businessID.businessName }}</td>
              <td>{{ (list && list.FarmSiteDetails && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.village) + ', ' + (list && list.FarmSiteDetails && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.district) }}</td>
              <td>{{ list.section_name }}</td>
              <td>{{ list.name }}</td>
              <td>{{ list.date  | date:"dd-MMM-yyyy" }}</td>
              <td>{{ list.serial_number }}</td>
              <td>{{ list.PreparatoryStage == 0 ? 'No' : 'Yes' }}</td>
              <td>{{ list.Nooftests }}</td>
              <td>
                <button type="button" class="dashboard-view-button" data-toggle="modal"
                        data-target="#exampleModalCenter" (click)="getAllTodayReadings(list.pondId)"><span class="icon"><img
                  src="../../../../../assets/images/New_Icons/view-icon.svg" width="20"></span>
                  <span class="text">View Readings</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModalCenter" role="dialog">
        <div class="modal-dialog modal-lg modal-sizelaign">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <span class="farmer">{{ dispPondName }}&nbsp;Readings</span>
            </div>
            <div class="modal-body srScrollbar" id="style-4" style="height: 402px; cursor: pointer">
              <div class="row eachcard" *ngFor="let reading of resultantReadings">
                <div class="row" *ngIf="reading && reading.climateModel && reading.climateModel.length==0">
                  <p class="climatedata">Weather details not available</p>
                </div>
                <div class="row weather_data" *ngIf="reading && reading.climateModel && reading.climateModel.length>0"
                     [hidden]="!pgLoad">
                  <div class="col-md-3 weather_time">
                    <p>{{ reading && reading.climateModel[0].date | date:"dd-MMM-yyyy" }}</p>
                    <p>{{ reading && reading.climateModel[0].time }}</p>
                  </div>
                  <div class="col-md-3"></div>
                  <div class="col-md-2">
                    <p class="tempcls">{{ reading && reading.climateModel[0].temperature.toFixed(2) }} <sup
                      class="degree">o</sup><sup>C</sup></p>
                    <p class="weather_icon"><img
                      src="../../../assets/img/climate_icons_gif/{{reading && reading.climateModel[0].icon=='clear-day'?'clear-day.gif':reading && reading.climateModel[0].icon=='clear-night'?'clear-night.gif':reading && reading.climateModel[0].icon=='rain'?'rain.gif':reading && reading.climateModel[0].icon=='snow'?'snow.gif':reading && reading.climateModel[0].icon=='sleet'?'sleet.gif':reading && reading.climateModel[0].icon=='wind'?'wind.gif':reading && reading.climateModel[0].icon=='fog'?'fog.gif':reading && reading.climateModel[0].icon=='cloudy'?'cloudy.gif':reading && reading.climateModel[0].icon=='partly-cloudy-day'?'partly-cloudy-day.gif':reading && reading.climateModel[0].icon=='partly-cloudy-night'?'partly-cloudy-night.gif':'Clear.png'}}"
                      width="70" height="70"
                      alt="icon"/></p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'clear-day'">Clear Day</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'clear-night'">Clear
                      Day</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'rain'">Rain</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'snow'">Snow</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'sleet'">Sleet</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'wind'">Wind</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'fog'">fog</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'cloudy'">Cloudy</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'partly-cloudy-day'">
                      Partly Cloudy Day</p>
                    <p class="weather_text" *ngIf="reading && reading.climateModel[0].icon == 'partly-cloudy-night'">
                      Partly Cloudy
                      Night</p>
                  </div>
                  <div class="col-md-3" style="margin-top: 20px;">
                    <p class="uvblock">
                      <span class="uvcolor"
                            *ngIf="(reading && reading.climateModel[0].uvIndex >= 0) && (reading && reading.climateModel[0].uvIndex <= 2)"
                            style="color: #3EA72D;">Low</span>
                      <span class="uvcolor"
                            *ngIf="(reading && reading.climateModel[0].uvIndex >2) && (reading && reading.climateModel[0].uvIndex <= 5)"
                            style="color: #FFF300;">Moderate</span>
                      <span class="uvcolor"
                            *ngIf="(reading && reading.climateModel[0].uvIndex >5) && (reading && reading.climateModel[0].uvIndex <= 7)"
                            style="color: #F18B00;">High</span>
                      <span class="uvcolor"
                            *ngIf="(reading && reading.climateModel[0].uvIndex >7) && (reading && reading.climateModel[0].uvIndex <= 10)"
                            style="color: #E53210;">Red</span>
                      <span class="uvcolor" *ngIf="(reading && reading.climateModel[0].uvIndex >10)"
                            style="color: #B567A4;">Extreme</span>
                      <span class="uv_value"> ({{ reading && reading.climateModel[0].uvIndex }})</span>
                      <span>UV Index</span>
                    </p>
                    <p class="windblock"><span class="wind_value">{{ reading && reading.climateModel[0].wind_speed }}
                      km/hr</span> <span>Wind</span></p>
                    <p class="humidblock"><span
                      class="windgust_value">{{ reading && reading.climateModel[0].humidity }}</span><span> Humidity</span>
                    </p>
                  </div>
                </div>
                <div class="row parameters_block">
                  <div class="row physical_params">
                    <div class="physical_heading" style="margin-bottom: 15px;">
                      <span>Physical Parameters</span><span class="lineimages"><img
                      src="../../../../../assets/img/line1.png"/></span>
                    </div>
                    <div class="col-md-1" *ngIf="reading.pH != null && reading.pH != -1">
                      <p class="params_values">{{ reading.pH }}</p>
                      <p>PH</p>
                    </div>
                    <div class="col-md-2" *ngIf="reading.salinity != null && reading.salinity != -1">
                      <p class="params_values">{{ reading.salinity }}</p>
                      <p>Salinity (ppt)</p>
                    </div>
                    <div class="col-md-1" *ngIf="reading.do2 != null && reading.do2 != -1">
                      <p class="params_values">{{ reading.do2 }}</p>
                      <p>DO (ppm)</p>
                    </div>
                    <div class="col-md-2" *ngIf="reading.turbidity != null && reading.turbidity != -1">
                      <p class="params_values">{{ reading.turbidity }}</p>
                      <p>Turbidity (ntu)</p>
                    </div>
                    <div class="col-md-2" *ngIf="reading.conductivity != null && reading.conductivity != -1">
                      <p class="params_values">{{ reading.conductivity }}</p>
                      <p>Conductivity (ms/cm)</p>
                    </div>
                    <div class="col-md-1" *ngIf="reading.temperature != null && reading.temperature != -1">
                      <p class="params_values">{{ reading.temperature }}</p>
                      <p>Temp (<sup>o</sup>C)</p>
                    </div>
                    <div class="col-md-2" *ngIf="reading.sg != null && reading.sg != -1">
                      <p class="params_values">{{ reading.sg }}</p>
                      <p>Specific Gravity</p>
                    </div>
                  </div>
                  <div class="row chemical_params" [hidden]="chemicalParams(reading)">
                    <div class="physical_heading"
                         *ngIf="(reading.nitrite != null && reading.nitrite != -1) || (reading.alkalinity != null && reading.alkalinity != -1) || (reading.tan != null && reading.tan != -1)">
                      <span>Chemical Parameters</span><span class="lineimages"><img
                      src="../../../../../assets/img/line1.png"/></span>
                    </div>
                    <div class="col-md-2" *ngIf="reading.nitrite != null && reading.nitrite != -1">
                      <p class="params_values">{{ reading.nitrite }}</p>
                      <p>Nitrite (ppm)</p>
                    </div>
                    <!--<div class="col-md-2" *ngIf="reading.calcium != null && reading.calcium != -1">
                      <p class="params_values">{{reading.calcium}}</p>
                      <p>Calcium (ppm)</p>
                    </div>-->
                    <!--<div class="col-md-2" *ngIf="reading.magnesium != null && reading.magnesium != -1">
                      <p class="params_values">{{reading.magnesium}}</p>
                      <p>Magnesium (ppm)</p>
                    </div>-->
                    <div class="col-md-2" *ngIf="reading.alkalinity != null && reading.alkalinity != -1">
                      <p class="params_values">{{ reading.alkalinity }}</p>
                      <p>Total Alkalinity (ppm)</p>
                    </div>
                    <!--<div class="col-md-2" *ngIf="reading.hardness != null && reading.hardness != -1">
                      <p class="params_values">{{reading.hardness}}</p>
                      <p>Hardness (ppm)</p>
                    </div>-->
                    <!--<div class="col-md-2" *ngIf="reading.carbonate != null && reading.carbonate != -1">
                      <p class="params_values">{{reading.carbonate}}</p>
                      <p>Carbonate (ppm)</p>
                    </div>-->
                    <!--<div class="col-md-2" *ngIf="reading.bicarbonate != null && reading.bicarbonate != -1">
                      <p class="params_values">{{reading.bicarbonate}}</p>
                      <p>Bicarbonate (ppm)</p>
                    </div>-->
                    <div class="col-md-3" *ngIf="reading.tan != null && reading.tan != -1">
                      <p class="params_values">{{ reading.tan }}</p>
                      <p>T.Ammonia Nitrogen (ppm)</p>
                    </div>
                    <!--<div class="col-md-2" *ngIf="reading.uam != null && reading.uam != -1">
                      <p class="params_values">{{reading.uam}}</p>
                      <p>Ammonia (ppm)</p>
                    </div>-->
                  </div>
                  <!--additional params-->
                  <div class="row additional_params"
                       *ngIf="reading.cust_added_params !=null && reading.cust_added_params !=''">
                    <div class="physical_heading">
                      <span>Additional Parameters</span><span class="lineimages"><img
                      src="../../../../../assets/img/line1.png"/></span>
                    </div>
                    <div class="col-md-2" *ngFor="let x of reading.cust_added_params">
                      <p class="params_values">{{ x.value }}</p>
                      <p><span class="">{{ getAddiParamOriginalVal(x.key) }}</span></p>
                    </div>
                  </div>
                  <!--comment-->
                  <div class="row comment_params" *ngIf="reading.comment !=null && reading.comment !=''">
                    <div class="physical_heading">
                      <span>Comment</span><span class="lineimages"><img
                      src="../../../../../assets/img/line1.png"/></span>
                    </div>
                    <div class="col-md-2">
                      <p class="params_values">{{ reading.comment }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End model view of readings data -->
      <!-- END BASIC TABLE SAMPLE -->
    </div>
  </div>
</div>
